import {
  TrainingPlan,
  TrainingPlanFormData,
  TrainingPlanQueryParams,
  TrainingPlanSaveData,
} from "../types"
import { ID, PaginationResult } from "@/types/common"
import { createCrudApi } from "@/utils/apiFactory"

const baseApi = createCrudApi<
  TrainingPlan,
  TrainingPlanSaveData,
  TrainingPlanSaveData
>("/training-plans")

// 训练计划API
const trainingPlanApi = {
  // 查询所有
  async getList(
    params: TrainingPlanQueryParams
  ): Promise<PaginationResult<TrainingPlan>> {
    return baseApi.list({
      studentId: params.studentId,
      trainingProjectId: params.trainingProjectId,
      domainLv1Id: params.domainLv1Id,
      domainLv2Id: params.domainLv2Id,
      ...(params.status && { status: params.status }),
      page: params.page,
      pageSize: params.pageSize,
    })
  },

  // ID查询
  async getById(id: ID): Promise<TrainingPlan | null> {
    return baseApi.getById(id)
  },

  // 创建
  async create(data: TrainingPlanSaveData): Promise<void> {
    const payload = {
      studentId: data.studentId,
      ...("trainingProjectIds" in data
        ? { trainingProjectIds: data.trainingProjectIds }
        : { trainingProjectId: data.trainingProjectId }),
      note: data.note || "",
      ...(data.expectedBeginDate && {
        expectedBeginDate: data.expectedBeginDate,
      }),
      ...(data.expectedEndDate && { expectedEndDate: data.expectedEndDate }),
      ...(data.actualBeginDate && { actualBeginDate: data.actualBeginDate }),
      ...(data.actualEndDate && { actualEndDate: data.actualEndDate }),
    }
    await baseApi.create(payload)
  },

  // 更新
  async update(id: ID, data: TrainingPlanFormData): Promise<void> {
    const payload = {
      studentId: data.studentId,
      trainingProjectId: data.trainingProjectId,
      note: data.note || "",
      ...(data.expectedBeginDate && {
        expectedBeginDate: data.expectedBeginDate,
      }),
      ...(data.expectedEndDate && { expectedEndDate: data.expectedEndDate }),
      ...(data.actualBeginDate && { actualBeginDate: data.actualBeginDate }),
      ...(data.actualEndDate && { actualEndDate: data.actualEndDate }),
    }
    await baseApi.update(id, payload)
  },

  // 删除（统一使用数组参数，支持单个和批量）
  async delete(ids: ID[]): Promise<void> {
    await baseApi.delete(ids)
  },
}

export default trainingPlanApi
